export default () => {
    let aliasDeleteModal = document.getElementById('aliasDeleteModal');
    if (!aliasDeleteModal) {
        return;
    }
    aliasDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let email = button.data('email');
        let alias = button.data('alias');
        let action = button.data('action');
        let redirect = button.data('redirect');

        let modal = $(this);
        modal.find('#aliasDelete').attr('action', action);
        modal.find('#email').val(email);
        modal.find('#alias').val(alias);
        modal.find('#redirect').val(redirect);
    });
};
